import { useEffect } from 'react'
import { Image } from 'react-native'

import { useNavigation, useRoute } from '@react-navigation/native'
import { Stack } from '@zet/design-system/layout'
import { B6, H3, H4, SH1, SH2 } from '@zet/design-system/typography'

import { i18n } from '../../localization'
import useStore from '../../store'
import useAuthStore from '../../store/authStore'

const SignupSuccess = () => {
  const { params } = useRoute()
  const navigation = useNavigation()
  const { user } = useStore((state) => state)
  const { setIsAuthenticated, isAuthenticated } = useAuthStore()

  useEffect(() => {
    setTimeout(() => {
      setIsAuthenticated(true)
      setTimeout(() => {
        navigation.replace('HomeView')
      }, 1000)
    }, 1000)
  }, [])

  return (
    <Stack className="flex-1 justify-center bg-white px-3">
      <H3 className="mx-4 text-center">
        {i18n.t('signupSuccess.congratulations')}
      </H3>
      <Stack
        className="border-grays-40 mt-4 self-center rounded-md border"
        style={{ width: 150, height: 150, overflow: 'hidden' }}
      >
        <Image
          source={{
            uri: user?.profilePicUrl,
          }}
          style={{ height: '100%' }}
        />
      </Stack>
      <Stack className="bg-grays-20 mx-4 mt-4 rounded-xl border-none py-2">
        <H4 className="text-center">{user?.name}</H4>
      </Stack>
      <Stack className="bg-grays-20 mx-4 mt-4 rounded-xl border-none py-2">
        <SH2 className="text-grays-60 text-center">
          {i18n.t('signupSuccess.financialAdvisor')} {'\n'}
          {'@ '}
          {params?.companyName}
        </SH2>
      </Stack>
      <SH1 className="mx-4 mt-4 text-center">
        {i18n.t('signupSuccess.success')}
      </SH1>
      <B6 className="absolute bottom-0 mb-8 self-center">
        {i18n.t('signupSuccess.settingUp')}
      </B6>
    </Stack>
  )
}

export default SignupSuccess
